import { render, staticRenderFns } from "./quill_editor.vue?vue&type=template&id=12559bae&"
import script from "./quill_editor.vue?vue&type=script&lang=js&"
export * from "./quill_editor.vue?vue&type=script&lang=js&"
import style0 from "./quill_editor.vue?vue&type=style&index=0&id=12559bae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports